/** Action types for conversational reducer. */
const CONVERSATIONAL_REDUCER_ACTIONS = {
    GET_TRAINED_MODEL_SUMMARIES: 'GET_TRAINED_MODEL_SUMMARIES'
};

const actionTypes = {
    USER_DROPDOWN_SHOW: 'USER_DROPDOWN_SHOW',
    USER_DROPDOWN_HIDE: 'USER_DROPDOWN_HIDE',
    SIDEBAR_TOGGLE: 'SIDEBAR_TOGGLE',
    SET_TENANT: 'SET_TENANT',
    GET_TENANT: 'GET_TENANT',
    CLEAR_STATE: 'CLEAR_STATE',
    SET_EDITED_STATUS: 'SET_EDITED_STATUS',
    SET_VIEW_MODE: 'SET_VIEW_MODE',

    // AUTH / USER MANAGEMENT
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    TENANT_REQUEST: 'TENANT_REQUEST',
    TENANT_ACCEPT: 'TENANT_ACCEPT',
    SET_ACCESS_TYPE: 'SET_ACCESS_TYPE',
    GET_ACCESS_TYPE: 'GET_ACCESS_TYPE',
    SET_USER_DETAILS: 'SET_USER_DETAILS',
    UPDATE_USER_STATE: 'UPDATE_USER_STATE',

    // PROJECT / QUESTION
    PROJECT_REQUEST: 'PROJECT_REQUEST',
    GET_PROJECTS: 'GET_PROJECTS',
    PROJECT_FETCH_DATA_SUCCESS: 'PROJECT_FETCH_DATA_SUCCESS',
    PROJECT_REQUEST_ERROR: 'PROJECT_REQUEST_ERROR',
    SET_PROJECT: 'SET_PROJECT',
    SET_PROJECT_STATUS: 'SET_PROJECT_STATUS',
    PREVIEW_PROJECT: 'PREVIEW_PROJECT',
    SET_BOT_SETTINGS: 'SET_BOT_SETTINGS',
    CLEAR_PROJECT: 'CLEAR_PROJECT',
    GET_ALL_QUESTIONS_FLOW: 'GET_ALL_QUESTIONS_FLOW',
    SORT_QUESTIONS: 'SORT_QUESTIONS',
    SORT_QUESTIONS_BY_GROUP: 'SORT_QUESTIONS_BY_GROUP',
    AFTER_SAVE_SORT_QUESTIONS: 'AFTER_SAVE_SORT_QUESTIONS',
    CREATE_QUESTION: 'CREATE_QUESTION',
    CREATE_QUESTIONS: 'CREATE_QUESTIONS',
    UPDATE_QUESTION: 'UPDATE_QUESTION',
    DUPLICATE_QUESTION: 'DUPLICATE_QUESTION',
    EDIT_QUESTION: 'EDIT_QUESTION',
    PREVIEW_QUESTION: 'PREVIEW_QUESTION',
    DELETE_QUESTION: 'DELETE_QUESTION',
    DELETE_QUESTIONS: 'DELETE_QUESTIONS',
    SET_ADD_NEW_QUESTION: 'SET_ADD_NEW_QUESTION',
    SET_ACTIVE_QUESTION: 'SET_ACTIVE_QUESTION',
    SET_EDIT_QUESTION: 'SET_EDIT_QUESTION',
    CLEAR_EDITED_STATUS: 'CLEAR_EDITED_STATUS',
    SET_LOGIC_QUESTION: 'SET_LOGIC_QUESTION',
    EDIT_GREETING: 'EDIT_GREETING',
    SET_SAMPLE: 'SET_SAMPLE',
    CLEAR_QUESTION_STATUS: 'CLEAR_QUESTION_STATUS',
    CHECK_PROJECT_HEALTH: 'CHECK_PROJECT_HEALTH',
    CLEAR_PROJECT_HEALTH: 'CLEAR_PROJECT_HEALTH',

    SET_LOCK_USER: 'SET_LOCK_USER',
    SET_EDIT_ENABLED: 'SET_EDIT_ENABLED',

    // MEDIA LIBRARY
    GET_ALL_MEDIA: 'GET_ALL_MEDIA',
    ADD_NEW_MEDIA: 'ADD_NEW_MEDIA',
    DELETE_MEDIA: 'DELETE_MEDIA',
    UPDATE_MEDIA: 'UPDATE_MEDIA',
    SORT_MEDIA: 'SORT_MEDIA',

    // OPTION PACK LIBRARY
    GET_ALL_OPTION_PACKS: 'GET_ALL_OPTION_PACKS',
    GET_SINGLE_OPTION_PACK: 'GET_SINGLE_OPTION_PACK',
    ADD_SINGLE_OPTION_PACK: 'ADD_SINGLE_OPTION_PACK',
    GET_PRICE: 'GET_PRICE',

    ...CONVERSATIONAL_REDUCER_ACTIONS
};

const SESSION = {
    SET_TENANT: 'SET_TENANT',
    GET_TENANT: 'GET_TENANT',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    TENANT_REQUEST: 'TENANT_REQUEST',
    TENANT_ACCEPT: 'TENANT_ACCEPT',
    SET_ACCESS_TYPE: 'SET_ACCESS_TYPE',
    GET_ACCESS_TYPE: 'GET_ACCESS_TYPE'
};

const USER = {
    USER_DROPDOWN_SHOW: 'USER_DROPDOWN_SHOW',
    USER_DROPDOWN_HIDE: 'USER_DROPDOWN_HIDE',
    SET_USER_DETAILS: 'SET_USER_DETAILS',
    CLEAR_STATE: 'CLEAR_STATE'
};

const SYSTEM = {};

const MENU = {
    SIDEBAR_TOGGLE: 'SIDEBAR_TOGGLE'
};

const PROJECT = {
    PROJECT_FETCH_DATA_SUCCESS: 'PROJECT_FETCH_DATA_SUCCESS',
    PROJECT_REQUEST_ERROR: 'PROJECT_REQUEST_ERROR',
    SET_PROJECT: 'SET_PROJECT',
    SET_PROJECT_STATUS: 'SET_PROJECT_STATUS',
    PREVIEW_PROJECT: 'PREVIEW_PROJECT',
    CLEAR_PROJECT: 'CLEAR_PROJECT'
};

const MEDIA = {
    GET_ALL_MEDIA: 'GET_ALL_MEDIA',
    ADD_NEW_MEDIA: 'ADD_NEW_MEDIA'
};

const QUESTION = {
    SET_BOT_SETTINGS: 'SET_BOT_SETTINGS',
    GET_ALL_QUESTIONS_FLOW: 'GET_ALL_QUESTIONS_FLOW',
    SORT_QUESTIONS: 'SORT_QUESTIONS',
    SORT_QUESTIONS_BY_GROUP: 'SORT_QUESTIONS_BY_GROUP',
    CREATE_QUESTION: 'CREATE_QUESTION',
    UPDATE_QUESTION: 'UPDATE_QUESTION',
    EDIT_GREETING: 'EDIT_GREETING',
    AFTER_SAVE_SORT_QUESTIONS: 'AFTER_SAVE_SORT_QUESTIONS',
    EDIT_QUESTION: 'EDIT_QUESTION',
    SET_ADD_NEW_QUESTION: 'SET_ADD_NEW_QUESTION',
    SET_EDIT_QUESTION: 'SET_EDIT_QUESTION',
    SET_LOGIC_QUESTION: 'SET_LOGIC_QUESTION',
    SET_SAMPLE: 'SET_SAMPLE',
    CLEAR_QUESTION_STATUS: 'CLEAR_QUESTION_STATUS',
    SET_DEMOGRAPHICS: 'SET_DEMOGRAPHICS'
};

const UTILS = {
    SET_EDITED_STATUS: 'SET_EDITED_STATUS',
    CLEAR_EDITED_STATUS: 'CLEAR_EDITED_STATUS'
};

export { MEDIA, MENU, PROJECT, QUESTION, SESSION, SYSTEM, USER, UTILS };

export default actionTypes;
